import { useFaro } from "../helpers/useFaro";
import { LogLevel } from "@grafana/faro-web-sdk";

export default {
  methods: {
    EmailFile: function () {
      if (
        this.$store.state.emailFile.email === null ||
        this.$store.state.emailFile.email === ""
      ) {
        this.$buefy.dialog.alert("メールアドレスが正しくありません");
        return;
      }

      this.OpenLoading("メールを送信中...");

      this.$axios
        .post(
          `/file/email?email=${this.$store.state.emailFile.email}`,
          this.$store.state.emailFile.file,
          { headers: { Authorization: `Bearer ${this.$store.state.token}` } },
        )
        .then(() => {
          this.$buefy.dialog.alert("メールが送信されました");
          this.CloseLoading();
          this.$store.state.emailFile.isModalOpen = false;
        })
        .catch((err) => {
          const faro = useFaro();
          faro.api.pushError(
            new Error(`EmailFile: [api] Failed to send email: ${err}`),
          );
          this.CloseLoading();
          this.toastError(`エラー：${err}`);
          this.$store.state.emailFile.isModalOpen = false;
        });
    },
    EmailFileModal: function (file) {
      this.$store.state.emailFile.isModalOpen = true;
      this.$store.state.emailFile.file = file;
    },
  },
};
